import { useEffect, useState } from 'react';
import { Label } from '../../../../components/forms/input';
import { Radio } from '../../../../components/forms/radio';
import { Select2 } from '../../../../components/forms/select';
import { ChildProps, MapLayerEditorContainer } from './map-layer-editor-container';
import { useQuery } from '../../../../hooks/use-query';
import { LayerField, LayerTypes } from '../../types/map-layer';
import { useParams } from 'react-router';

export const Animation = (): JSX.Element => {
  const params = useParams();
  const layerId = params.id as string;
  const fields = useQuery<LayerField[]>({ path: `/map-layers/${layerId}/fields` });

  return <>
    <MapLayerEditorContainer>
      {(props: ChildProps): JSX.Element => {
        const [currentValue, setCurrentValue] = useState<string>('');
        const layerType = props.getValues?.()?.type as LayerTypes;

        useEffect(() => {
          if (!currentValue) {
            setExistingValues();
          }
        }, [props.getValues()]);

        const setExistingValues = (): void => {
          props.setValue('animationFieldId', props.getValues().animationFieldId);
          props.setValue('animationType', props.getValues().animationType);
          setCurrentValue(props.getValues().animationType as string);
        };

        return <>
          {[LayerTypes.WEATHER_MODEL_LAYER, LayerTypes.FOLDER, LayerTypes.HP_POINT_LAYER, LayerTypes.WMS_LINE_LAYER, LayerTypes.AGS_LAYER, LayerTypes.WMTS_TILE_LAYER,
            LayerTypes.VIRTUAL_LAYER, LayerTypes.COMMERCIAL_BASEMAP, LayerTypes.WMS_POLYGON_LAYER, LayerTypes.WMS_RASTER_LAYER].includes(layerType) && (
            <div className="mb-4">
              <Radio {...props.register('animationType')} label="Do not animate" value="DO_NOT_ANIMATE" currentValue={currentValue} onChange={(event): void => setCurrentValue(event.target.value)} />
            </div>
          )}
          {LayerTypes.VIRTUAL_LAYER === layerType && (
            <div className="mb-4">
              <Radio {...props.register('animationType')} label="Virtual Layer Animation" value="VIRTUAL_LAYER_ANIMATION" currentValue={currentValue} onChange={(event): void => setCurrentValue(event.target.value)} />
            </div>
          )}
          {LayerTypes.WMS_RASTER_LAYER === layerType && (
            <div className="mb-4">
              <Radio {...props.register('animationType')} label="Raster Animation" value="RASTER_ANIMATION" currentValue={currentValue} onChange={(event): void => setCurrentValue(event.target.value)} />
            </div>
          )}
          {LayerTypes.AGS_LAYER === layerType && (
            <div className="mb-4">
              <Radio {...props.register('animationType')} label="Feature Animation" value="FEATURE_ANIMATION" currentValue={currentValue} onChange={(event): void => setCurrentValue(event.target.value)} />
            </div>
          )}
          {currentValue === 'FEATURE_ANIMATION' && (
            <>
              <div className="mb-4">
                <Label name="name">Field</Label>
                <Select2 {...props.register('animationFieldId')}>
                  <option value="">Select Field To Animate</option>
                  {fields.data?.map(field => {
                    return <option key={field.id} value={field.id}>{field.fieldName}</option>;
                  })}
                </Select2>
              </div>
              {/* <div className="mb-4">*/}
              {/*  <Label name="name">Field Type</Label>*/}
              {/*  <Select2 {...props.register('type')}>*/}
              {/*    <option value="">Select Field Type</option>*/}
              {/*    {fieldTypes.map(fieldType => {*/}
              {/*      return <option key={fieldType.value} value={fieldType.value}>{fieldType.label}</option>;*/}
              {/*    })}*/}
              {/*  </Select2>*/}
              {/* </div>*/}
              {/* <div className="mb-4">*/}
              {/*  <Label name="name">Timeline Axis</Label>*/}
              {/*  <Select2 {...props.register('type')}>*/}
              {/*    <option value="">Select Timeline Axis</option>*/}
              {/*    {axis.map(axis => {*/}
              {/*      return <option key={axis.value} value={axis.value}>{axis.label}</option>;*/}
              {/*    })}*/}
              {/*  </Select2>*/}
              {/* </div>*/}
            </>
          )}
        </>;
      }}
    </MapLayerEditorContainer>
  </>;
};
